import MyOfficeAssignmentDetailAdmin from '../Contents/Operations/Assignments/MyOfficeAssignment/MyOfficeAssignmentDetailAdmin';
import FieldTypesEnum from '../Enums/FieldTypesEnum';
import TabListTableCellWidthEnum from '../Enums/TabListTableCellWidthEnum';
import React from 'react';

export default class MyOfficeAssignmentSummaryItem {
  constructor(item) {
    if (item === undefined) {
      this.CompletedDate = '';
      this.CfLdvid = 0;
      this.OfficeName = '';
      this.NumReadyForInvoicing = '';
      this.NumNotReadyForInvoicing = '';
      this.NumPendingPe = '';
    } else {
      this.CompletedDate = item.completedDate;
      this.CfLdvid = item.cfLdvid;
      this.OfficeName = item.officeName;
      this.NumReadyForInvoicing = item.numReadyForInvoicing;
      this.NumNotReadyForInvoicing = item.numNotReadyForInvoicing;
      this.NumPendingPe = item.numPendingPe;
      this.IdField = item.completedDate.toString() + '_' + item.cfLdvid.toString();
    }
  }

  static NameOfTheIdField() {
    return 'IdField';
  }

  static nameOfTheItemDetailList(item) {
    if (item) return <span>Completed On - {item.CompletedDate}</span>;
    return 'Completed On';
  }

  static MoneyFields = [];

  static Currency() {
    return '';
  }

  static MoneyFieldsSecondary = [];

  static CurrencySecondary() {
    return '';
  }

  static DateFields = [];

  static FieldsToShowInListTable = [
    {
      tabName: 'Projects',
      tabLabel: 'Projects',
      icon: 'fa-brands fa-grav fa-2x',
      data: [
        {
          name: (item) => (
            <MyOfficeAssignmentDetailAdmin
              completedDate={item.CompletedDate}
              officeId={item.CfLdvid}
            />
          ),
          label: 'Projects',
          width: TabListTableCellWidthEnum.Table,
        },
      ],
    },
  ];

  static FieldsToShowInDataTable() {
    return [
      {
        label: 'Completed Date',
        orderById: 'CompletedDate',
        data: 'CompletedDate',
        type: FieldTypesEnum.DataFieldWithDetails,
      },
      {
        label: 'Office',
        orderById: 'OfficeName',
        data: 'OfficeName',
        type: FieldTypesEnum.PureDataField,
      },
      {
        label: 'Ready For Invoicing',
        orderById: 'NumReadyForInvoicing',
        data: 'NumReadyForInvoicing',
        type: FieldTypesEnum.PureDataField,
      },
      {
        label: 'Not Ready For Invoicing',
        orderById: 'NumNotReadyForInvoicing',
        data: 'NumNotReadyForInvoicing',
        type: FieldTypesEnum.PureDataField,
      },
      {
        label: 'Pending PE',
        orderById: 'NumPendingPe',
        data: 'NumPendingPe',
        type: FieldTypesEnum.PureDataField,
      },
    ];
  }
}
